// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1x1pJ","buttons":"RemoveExpirationActionButtons_buttons__v2_1w"};